<div class="report-wrapper">
    <h3 class="text"> Page not found or You are not authorized to access application
    </h3>

</div>